<div class="mainContent">
  <div style="height: 7vh">
    <div>
      <label
        i18n="@@spmsUserReg"
        class="textColour"
        [ngStyle]="{ 'border-color': backgroundColorButton }"
        >Requirements Library</label
      >
      <span class="example-spacer"></span>
    </div>
  </div>

  <div
    style="
      height: 57vh;
      overflow: auto;
      padding-left: 4%;
      padding-right: 4%;
      padding-top: 2%;
    "
  >
    <form [formGroup]="FormValid" novalidate>
      <!-- row 1 -->
      <div class="row">
        <!-- System -->
        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>System</mat-label>

            <mat-select formControlName="systemId" (selectionChange)="onSystemChange($event.value)">
              <mat-option *ngFor="let system of systems" [value]="system.id">
                {{ system.systemName }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="FormValid.get('systemId')?.hasError('required')">
              System is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Release -->
        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Release</mat-label>

            <mat-select formControlName="releaseId">
              <mat-option *ngFor="let release of releases" [value]="release.id">
                {{ release.releaseName }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="FormValid.get('releaseId')?.hasError('required')">
              Release is required.
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Module -->
        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Module</mat-label>

            <mat-select multiple formControlName="moduleId">
              <mat-option
                *ngFor="let module of modules"
                [value]="module.modulemstrid"
              >
                {{ module.modulename }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="FormValid.get('moduleId')?.hasError('required')">
              Module is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- row 2 -->
      <div class="row">
        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Requirement Number</mat-label>

            <input matInput formControlName="requirementNumber" />

            <mat-error
              *ngIf="FormValid.get('requirementNumber')?.hasError('required')"
            >
              Requirement Number is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Title</mat-label>

            <input matInput formControlName="title" />

            <mat-error *ngIf="FormValid.get('title')?.hasError('required')">
              Title is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Requirement Classification</mat-label>

            <mat-select multiple formControlName="requirementClassification">
              <mat-option
                *ngFor="let item of Requirement_Classification"
                [value]="item.lookupvalueid"
              >
                {{ item.lookupvalue }}
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="
                FormValid.get('requirementClassification')?.hasError('required')
              "
            >
              Requirement Classification is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- row 3 -->
      <div class="row">
        <div class="col-lg-12">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Description</mat-label>

            <textarea
              matInput
              rows="2"
              formControlName="description"
            ></textarea>

            <mat-error
              *ngIf="FormValid.get('description')?.hasError('maxlength')"
            >
              Description cannot exceed 5000 characters.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- row 5 -->
      <div class="row">
        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Severity</mat-label>

            <mat-select formControlName="severity">
              <mat-option
                *ngFor="let item of Severity"
                [value]="item.lookupvalueid"
              >
                {{ item.lookupvalue }}
              </mat-option>
            </mat-select>

            <mat-error *ngIf="FormValid.get('severity')?.hasError('required')">
              Severity is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Probability</mat-label>

            <mat-select formControlName="probability">
              <mat-option
                *ngFor="let item of Probability"
                [value]="item.lookupvalueid"
              >
                {{ item.lookupvalue }}
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="FormValid.get('probability')?.hasError('required')"
            >
              Probability is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Detectability</mat-label>

            <mat-select formControlName="detectability">
              <mat-option
                *ngFor="let item of Detectability"
                [value]="item.lookupvalueid"
              >
                {{ item.lookupvalue }}
              </mat-option>
            </mat-select>

            <mat-error
              *ngIf="FormValid.get('detectability')?.hasError('required')"
            >
              Detectability is required.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- row 6 -->
      <div class="row">
        <div class="col-lg-4">
          <div
            style="
              display: flex;
              align-items: flex-start;
              gap: 8px;
              width: 100%;
            "
          >
            <mat-form-field appearance="outline" style="flex: 1">
              <mat-label>Risk Rating</mat-label>

              <mat-select formControlName="riskRating">
                <mat-option
                  *ngFor="let item of Risk_Rating"
                  [value]="item.lookupvalueid"
                >
                  {{ item.lookupvalue }}
                </mat-option>
              </mat-select>

        

              <mat-error
                *ngIf="FormValid.get('riskRating')?.hasError('required')"
              >
                Please select or calculate the Risk Rating.
              </mat-error>
            </mat-form-field>

            <button
              mat-icon-button
              type="button"
              (click)="calculateRiskRating()"
              matTooltip="Calculate Risk Rating"
             
            >
              <mat-icon>calculate</mat-icon>
            </button>
          </div>
        </div>

        <div class="col-lg-6">
          <mat-form-field appearance="outline" class="w-100"
    *ngIf="FormValid.get('riskRatingChangeRationale')?.validator">

    <mat-label>Risk Rating Change Justification</mat-label>

    <textarea
        matInput
        rows="3"
        formControlName="riskRatingChangeRationale">
    </textarea>

    <mat-error
        *ngIf="FormValid.get('riskRatingChangeRationale')?.hasError('required')">
        Justification is required when Risk Rating is changed manually.
    </mat-error>

</mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div style="height: 5vh">
    <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%">
      <div class="col-lg text-center">
        <div
          style="
            text-align: end;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          "
        >
          <!-- <form [formGroup]="formValidCheckbox">

                <span *ngIf="buttonName == 'Save'">
                  <mat-checkbox
                    formControlName="isCheckboxSelected"
                    [(ngModel)]="isCheckboxSelected">
                  </mat-checkbox>

                  <span>Create Another</span>
                </span>

          </form> -->

          <!-- <button i18n="@@TargetClear" type="button" (click)="updateData()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">{{this.buttonName}}</button> -->

          <app-common-button
            label="{{ this.buttonName }}"
            title="{{ this.buttonName }}"
            [buttonId]="1111"
            width="110px"
            [critical]="false"
            (clicked)="updateData()"
            style="margin-left: 6px; margin-right: 6px"
          >
          </app-common-button>

          <!-- <button i18n="@@TargetCancel" type="button" (click)="close()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button> -->

          <app-common-button
            label="Cancel"
            title="Cancel "
            [buttonId]="1111"
            variant="cancel"
            width="110px"
            [critical]="false"
            (clicked)="close()"
            style="margin-left: 6px; margin-right: 6px"
          >
          </app-common-button>
        </div>
      </div>
    </div>
  </div>
</div>